import React, { useContext, useEffect, useState } from "react";
import "./AccountSettings.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { AppContext } from "../../Util/contexts/AppContext";
import ProfileDetails from "./Components/ProfileDetails";
import DemoAccountDetails from "./Components/DemoAccountDetails";
import Themes from "./Components/Themes";
import ChangePassword from "./Components/ChangePassword";
import ReportBug from "./Components/ReportBug";
import DisableAnimations from "./Components/DisableAnimations";
import Profession from "./Components/Profession";
import ViewFaq from "./Components/ViewFaq";
import Resubscribe from "./Components/Resubscribe";
import TimeZone from "./Components/TimeZone";
import DisableGradingFeedback from "./Components/DisableGradingFeedback";
import ChangeSignature from "./Components/ChangeSignature";
import PrintReceipt from "./Components/PrintReceipt";
import ChangePasswordPage from "./Subpages/ChangePasswordPage";
import ReportBugPage from "./Subpages/ReportBugPage";
import FaqPage from "./Subpages/FaqPage";
import ToggleShowPauseButton from "./Components/ToggleShowPauseButton";
import TimeZoneOverride from "./Components/TimeZoneOverride";
const AccountSettings = () => {
  const { userData, selectedTheme, setPageDisplayed } = useContext(AppContext);
  const [settingsSubpage, setSettingsSubpage] = useState("Settings");
  const [successMessage, setSuccessMessage] = useState(null);

  useEffect(() => {
    var metaThemeColor = document.querySelector("meta[name=theme-color]");
    metaThemeColor.setAttribute(
      "content",
      selectedTheme.tertiaryBackgroundColor
    );
  }, [selectedTheme.tertiaryBackgroundColor]);

  const changeSettingsPage = (newPage) => {
    setSettingsSubpage(newPage);
  };

  useEffect(() => {
    let pageWrapper = document.getElementById("accountSettingsPageContainer");
    if (pageWrapper) {
      pageWrapper.scrollIntoView({ block: "start", inline: "nearest" });
    }
  }, [settingsSubpage]);

  return (
    <div
      className="accountSettingsPageContainer"
      id="accountSettingsPageContainer"
    >
      <nav className="accountSettingsNavbar">
        <h1 className="caseListLogoText">
          OCC<span className="caseListLogoTextNormal">English</span>
        </h1>
      </nav>
      {settingsSubpage === "Settings" ? (
        <div
          className="accountSettingsBodyWrapper"
          id="SettingsPage"
          key="SettingsPage"
        >
          <button
            className="accountSettingsBackButton tertiaryButton"
            onClick={() => setPageDisplayed("ExamCreator")}
          >
            <FontAwesomeIcon
              icon={faArrowLeft}
              className="accountSettingsBackArrowIcon"
            />
            Back to Case List
          </button>
          {successMessage && (
            <div className="accountSettingsSuccessMessageContainer">
              <p className="accountSettingsSuccessMessageText">
                {successMessage}
              </p>
              <button
                className="accountSettingsSuccessCloseButton"
                onClick={() => setSuccessMessage(null)}
              />
            </div>
          )}
          <div className="accountSettingsTitleContainer" key="Title Container">
            <h1 className="accountSettingsTitle">Account Settings</h1>
            <button
              className="accountSettingsTitleButton"
              onClick={() => window.location.reload()}
            >
              Logout
            </button>
          </div>
          <ProfileDetails />
          {userData.demo && <DemoAccountDetails />}
          <Themes />
          <div className="accountSettingsCardColumn1">
            <ChangePassword changeSettingsPage={changeSettingsPage} />
            <ReportBug changeSettingsPage={changeSettingsPage} />
            <DisableAnimations />
            <ToggleShowPauseButton />
            <Profession />
            <ViewFaq changeSettingsPage={changeSettingsPage} />
          </div>
          <div className="accountSettingsCardColumn2">
            <Resubscribe />
            <TimeZone />
            <TimeZoneOverride />
            <ChangeSignature />
            <PrintReceipt />
          </div>
        </div>
      ) : settingsSubpage === "ChangePassword" ? (
        <ChangePasswordPage
          changeSettingsPage={changeSettingsPage}
          setSuccessMessage={(message) => setSuccessMessage(message)}
        />
      ) : settingsSubpage === "ReportBug/Feedback" ? (
        <ReportBugPage
          changeSettingsPage={changeSettingsPage}
          setSuccessMessage={(message) => setSuccessMessage(message)}
        />
      ) : (
        settingsSubpage === "FAQ" && (
          <FaqPage changeSettingsPage={changeSettingsPage} />
        )
      )}
    </div>
  );
};

export default AccountSettings;
